import { useRecordContext } from "react-admin"

const TagTitle = () => {
  const record = useRecordContext()

  return <span>{record ? `"${record.label}"` : ""}</span>
}

export { TagTitle }
